import {Button, Form, Input, Row, Typography} from "antd";
import React from "react";

const {Title, Paragraph} = Typography;
export default function TypingView(props) {
    const {startRideReq} = props;
return <div className='selection-methods'>
    <Row justify={'center'}>
        <h1 className='f-30 my-1 text-center ' style={{color: '#fff', textAlign: 'center'}}> شروع سفر</h1>
    </Row>
    <Row justify={'center'}>
        <Paragraph className='mb-36 f-14 text-center' style={{color: 'white',}}>یک بارکد روی بدنه وسیله نقلیه رورو نصب
            شده است. آن را وارد کنید </Paragraph>
    </Row>
    <div className='clearfix'>
        <div className='vehicle-selection-methods'>
            <Form onFinish={startRideReq}>
                <Form.Item className='no-red-star mb-32' name="scanCode" rules={[{required: true}]}
                           label='بارکد اسکوتر'>
                    <Input dir="ltr" className="scooter-barcode-input transparent"/>
                </Form.Item>
                <Form.Item>
                    <Button className='btn-qr-code' type="primary" htmlType="submit" block={true}
                            style={{borderRadius: "5px"}} size='large'>
                        شروع سفر
                    </Button>
                </Form.Item>
            </Form>
        </div>
    </div>
</div>;
}